import React, { useState } from "react";
import Study_Program_Card from "../../../../../common_components/common-cards/study-prgram-card/Study_Program_Card";
import Study_Program_Details from "../../../../../common_components/common-cards/study-program-details/Study_Program_Details";
import { useSelector } from "react-redux";

const Study_Program = ({
  isMyApplications = false,
  onShowDetails,
  onBackToList,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const collegelist = useSelector(
    (state) => state.studentapplication.studentapplications?.data || []
  );

  const handleViewDetails = (program) => {
    setSelectedProgram(program);
    if (onShowDetails) onShowDetails(); // tell parent to hide header
  };

  const handleBack = () => {
    setSelectedProgram(null);
    if (onBackToList) onBackToList(); // tell parent to show header
  };

  return (
    <div className="">
      {/* ======================== DETAIL VIEW ====================== */}

      {selectedProgram && (
        <Study_Program_Details
          schoolLogo={selectedProgram.University?.logo}
          schoolName={selectedProgram.University?.title}
          address={selectedProgram.University?.address}
          countryFlag={selectedProgram.University?.country_logo}
          bannerImg={selectedProgram.University?.image}
          programTitle={selectedProgram.Course?.name}
          programSubtitle={selectedProgram.Course?.name}
          description={selectedProgram.University?.description}
          highlights={selectedProgram.Study_Program_Highlights}
          eligibility={selectedProgram.Study_Program_Eligibilities}
          careers={selectedProgram.Study_Program_Careers}
          documents={selectedProgram.Study_Program_Documents}
          applicationFee={selectedProgram.application_fees}
          tuitionFee={selectedProgram.tution_fees}
          deadline={selectedProgram.application_deadline}
          onBack={handleBack}
        />
      )}

      {/* ================= CARD VIEW ================= */}

      {/* CARD VIEW */}
      {!selectedProgram && (
        <div className="row g-4 mt-4">
          {collegelist.map((program) => (
            <div key={program.id} className="col-lg-4 col-md-6 col-sm-12">
              <Study_Program_Card
                universityLogo={program.University?.logo}
                universityName={program.University?.title}
                programImage={program.University?.image}
                programName={program.Course?.name}
                description={program.University?.description}
                countryFlag={program.University?.country_logo}
                fees={program.tution_fees}
                feesCurrency="€"
                documents={program.Study_Program_Documents}
                onViewDetails={() => handleViewDetails(program)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Study_Program;
